export const getOwnerID = (slug) => {
  const arr = slug.split('-');
  return +arr.slice(-1);
};

export const getHostPublicProfileSlug = (name, id) => {
  const slug = name.replace(/[^0-9a-zA-Z\-\s]/g, '').toLocaleLowerCase()
    .split(' ').filter(Boolean)
    .join('-');
  return `${slug}-${id}`;
};
